import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["youtubeContent", "tiktokContent", "defaultContent"]
  static values = { storageKey: { type: String, default: "traffic_source" } }

  connect() {
    const source = this.detectSource() || sessionStorage.getItem(this.storageKeyValue)
    if (!source) return

    sessionStorage.setItem(this.storageKeyValue, source)

    if (source === "youtube") {
      this.youtubeContentTargets.forEach(el => el.classList.remove("hidden"))
      this.defaultContentTargets.forEach(el => el.classList.add("hidden"))
    } else if (source === "tiktok") {
      this.tiktokContentTargets.forEach(el => el.classList.remove("hidden"))
      this.defaultContentTargets.forEach(el => el.classList.add("hidden"))
    }
  }

  detectSource() {
    const params = new URLSearchParams(window.location.search)
    const utmSource = (params.get("utm_source") || "").toLowerCase()

    if (utmSource === "youtube" || /youtube\.com/.test(document.referrer)) return "youtube"
    if (utmSource === "tiktok" || /tiktok\.com/.test(document.referrer)) return "tiktok"
    return null
  }
}
